module.exports = __webpack_public_path__ + "img/dall.7661bc3e.webp";